import cx from 'classnames';
import React, { type FC, useState } from 'react';

import Arrow from '~assets/images/ui/icon_arrow_left.svg';

export enum ButtonVariant {
	PRIMARY = 'btn-theme btn-rounded',
	PRIMARY_WITH_LOADER = 'btn-theme btn-rounded with-loader',
	UNDERLINE = 'btn btn-underlined',
	BACK = 'btn btn-back',
	TRANSPARENT = 'btn btn-transparent',
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
	variant?: ButtonVariant;
	showSpinner?: boolean;
};

export const Button: FC<ButtonProps> = ({
	children,
	className,
	variant = ButtonVariant.PRIMARY,
	onClick,
	showSpinner,
	...restProps
}) => {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<button
			className={cx(variant, className)}
			onClick={async (e) => {
				try {
					if (isLoading && ButtonVariant.PRIMARY_WITH_LOADER) {
						return;
					}
					setIsLoading(true);
					await onClick?.(e);
					setIsLoading(false);
				} catch (error) {
					setIsLoading(false);
					throw error;
				}
			}}
			{...restProps}
		>
			{(isLoading || showSpinner) && ButtonVariant.PRIMARY_WITH_LOADER && (
				<div
					className="spinner-border text-light spinner-border-sm"
					role="status"
				/>
			)}
			{variant === ButtonVariant.BACK && (
				<img src={Arrow} alt="Arrow" width={19} height={19} />
			)}
			{children}
		</button>
	);
};
